<h2 mat-dialog-title>What these terms mean</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="glossary__search">
    <mat-label>Find a term</mat-label>
    <input matInput [formControl]="search" data-testid="glossary-search" />
  </mat-form-field>

  @if (entries().length) {
    <dl class="glossary">
      @for (e of entries(); track e.key) {
        <div class="glossary__entry" [attr.data-testid]="'glossary-' + e.key">
          <dt class="glossary__term">
            {{ e.term }}
            @if (onPage.has(e.key)) {
              <span class="glossary__here">on this page</span>
            }
          </dt>
          <dd class="glossary__meaning">{{ e.meaning }}</dd>
          <dd class="glossary__for-you">{{ e.forYou }}</dd>
          <dd class="glossary__rule">Rule: {{ e.rule }} · glossary entry {{ e.version }}</dd>
        </div>
      }
    </dl>
  } @else {
    <p class="glossary__none">No term matches that.</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" mat-dialog-close>Close</button>
</mat-dialog-actions>
